<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
  <li>
    <a [routerLink]="['/']">Home</a>
  </li>
  <li>
    <span>Activated Tasks Kanban View</span>
  </li>
</ul>

<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong>Activated Tasks - Kanban Board</strong>
    </span>
    <button type="button" class="btn btn-sm btn-default pull-right btn-back" (click)="back()" style="margin-left: 10px;">
      <i class="fa fa-chevron-circle-left"></i>&nbsp;Back to List
    </button>
    <button type="button" class="btn btn-sm btn-success pull-right" (click)="exportToExcel()" style="margin-left: 10px;">
      <i class="fa fa-file-excel-o"></i>&nbsp;Export to Excel
    </button>
    <button type="button" class="btn btn-sm btn-primary pull-right" (click)="refreshKanban()">
      <i class="fa fa-refresh"></i>&nbsp;Refresh
    </button>
  </div>

  <div class="card-block" style="padding: 20px;">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="text-center" style="padding: 50px;">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
      <p style="margin-top: 20px;">Loading tasks...</p>
    </div>

    <!-- Kanban Board -->
    <div *ngIf="!isLoading" class="kanban-board">
      <div class="kanban-container">
        
        <!-- Pending Column -->
        <div class="kanban-column" (dragover)="onDragOver($event)" (drop)="onDrop($event, 1)">
          <div class="kanban-header" [style.background-color]="getStatusColor(1)">
            <h5 class="kanban-title">
              <i class="fa fa-clock-o"></i> Pending
              <span class="badge badge-light">{{ getTaskCount(1) }}</span>
            </h5>
          </div>
          <div class="kanban-body">
            <div *ngFor="let task of pendingTasks" 
                 class="kanban-card" 
                 draggable="true"
                 (dragstart)="onDragStart($event, task, 1)">
              <div class="card-content">
                <div class="task-header">
                  <h6 class="task-name" [title]="task.TaskName">{{ truncateTaskName(task.TaskName) }}</h6>
                  <button class="btn-eye" (click)="viewTaskDetails(task); $event.stopPropagation()" title="View Details">
                    <i class="fa fa-eye"></i>
                  </button>
                </div>
                <p class="task-description" *ngIf="task.Description">{{ task.Description }}</p>
                <div class="task-meta">
                  <div class="meta-item" *ngIf="task.DueDate">
                    <i class="fa fa-calendar"></i>
                    <span>{{ formatDate(task.DueDate) }}</span>
                  </div>
                  <div class="meta-item" *ngIf="task.AssignedUserName">
                    <i class="fa fa-user"></i>
                    <span>{{ task.AssignedUserName }}</span>
                  </div>
                  <div class="meta-item" *ngIf="task.CategoryName">
                    <i class="fa fa-tag"></i>
                    <span>{{ task.CategoryName }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="pendingTasks.length === 0" class="empty-state">
              No pending tasks
            </div>
          </div>
        </div>

        <!-- Completed Column -->
        <div class="kanban-column" (dragover)="onDragOver($event)" (drop)="onDrop($event, 2)">
          <div class="kanban-header" [style.background-color]="getStatusColor(2)">
            <h5 class="kanban-title">
              <i class="fa fa-check-circle"></i> Completed
              <span class="badge badge-light">{{ getTaskCount(2) }}</span>
            </h5>
          </div>
          <div class="kanban-body">
            <div *ngFor="let task of completedTasks" 
                 class="kanban-card" 
                 draggable="true"
                 (dragstart)="onDragStart($event, task, 2)">
              <div class="card-content">
                <div class="task-header">
                  <h6 class="task-name" [title]="task.TaskName">{{ truncateTaskName(task.TaskName) }}</h6>
                  <button class="btn-eye" (click)="viewTaskDetails(task); $event.stopPropagation()" title="View Details">
                    <i class="fa fa-eye"></i>
                  </button>
                </div>
                <p class="task-description" *ngIf="task.Description">{{ task.Description }}</p>
                <div class="task-meta">
                  <div class="meta-item" *ngIf="task.CompletedDate">
                    <i class="fa fa-calendar-check-o"></i>
                    <span>{{ formatDate(task.CompletedDate) }}</span>
                  </div>
                  <div class="meta-item" *ngIf="task.AssignedUserName">
                    <i class="fa fa-user"></i>
                    <span>{{ task.AssignedUserName }}</span>
                  </div>
                  <div class="meta-item" *ngIf="task.CategoryName">
                    <i class="fa fa-tag"></i>
                    <span>{{ task.CategoryName }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="completedTasks.length === 0" class="empty-state">
              No completed tasks
            </div>
          </div>
        </div>

        <!-- Delayed Completion Column -->
        <div class="kanban-column" (dragover)="onDragOver($event)" (drop)="onDrop($event, 3)">
          <div class="kanban-header" [style.background-color]="getStatusColor(3)">
            <h5 class="kanban-title">
              <i class="fa fa-exclamation-triangle"></i> Delayed
              <span class="badge badge-light">{{ getTaskCount(3) }}</span>
            </h5>
          </div>
          <div class="kanban-body">
            <div *ngFor="let task of delayedTasks" 
                 class="kanban-card" 
                 draggable="true"
                 (dragstart)="onDragStart($event, task, 3)">
              <div class="card-content">
                <div class="task-header">
                  <h6 class="task-name" [title]="task.TaskName">{{ truncateTaskName(task.TaskName) }}</h6>
                  <button class="btn-eye" (click)="viewTaskDetails(task); $event.stopPropagation()" title="View Details">
                    <i class="fa fa-eye"></i>
                  </button>
                </div>
                <p class="task-description" *ngIf="task.Description">{{ task.Description }}</p>
                <div class="task-meta">
                  <div class="meta-item" *ngIf="task.DueDate">
                    <i class="fa fa-calendar"></i>
                    <span>{{ formatDate(task.DueDate) }}</span>
                  </div>
                  <div class="meta-item" *ngIf="task.AssignedUserName">
                    <i class="fa fa-user"></i>
                    <span>{{ task.AssignedUserName }}</span>
                  </div>
                  <div class="meta-item" *ngIf="task.CategoryName">
                    <i class="fa fa-tag"></i>
                    <span>{{ task.CategoryName }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="delayedTasks.length === 0" class="empty-state">
              No delayed tasks
            </div>
          </div>
        </div>

        <!-- Partially Completed Column -->
        <div class="kanban-column" (dragover)="onDragOver($event)" (drop)="onDrop($event, 4)">
          <div class="kanban-header" [style.background-color]="getStatusColor(4)">
            <h5 class="kanban-title">
              <i class="fa fa-tasks"></i> Partially Completed
              <span class="badge badge-light">{{ getTaskCount(4) }}</span>
            </h5>
          </div>
          <div class="kanban-body">
            <div *ngFor="let task of partiallyCompletedTasks" 
                 class="kanban-card" 
                 draggable="true"
                 (dragstart)="onDragStart($event, task, 4)">
              <div class="card-content">
                <div class="task-header">
                  <h6 class="task-name" [title]="task.TaskName">{{ truncateTaskName(task.TaskName) }}</h6>
                  <button class="btn-eye" (click)="viewTaskDetails(task); $event.stopPropagation()" title="View Details">
                    <i class="fa fa-eye"></i>
                  </button>
                </div>
                <p class="task-description" *ngIf="task.Description">{{ task.Description }}</p>
                <div class="task-meta">
                  <div class="meta-item" *ngIf="task.DueDate">
                    <i class="fa fa-calendar"></i>
                    <span>{{ formatDate(task.DueDate) }}</span>
                  </div>
                  <div class="meta-item" *ngIf="task.AssignedUserName">
                    <i class="fa fa-user"></i>
                    <span>{{ task.AssignedUserName }}</span>
                  </div>
                  <div class="meta-item" *ngIf="task.CategoryName">
                    <i class="fa fa-tag"></i>
                    <span>{{ task.CategoryName }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="partiallyCompletedTasks.length === 0" class="empty-state">
              No partially completed tasks
            </div>
          </div>
        </div>

        <!-- Done Column -->
        <div class="kanban-column" (dragover)="onDragOver($event)" (drop)="onDrop($event, 6)">
          <div class="kanban-header" [style.background-color]="getStatusColor(6)">
            <h5 class="kanban-title">
              <i class="fa fa-check"></i> Done
              <span class="badge badge-light">{{ getTaskCount(6) }}</span>
            </h5>
          </div>
          <div class="kanban-body">
            <div *ngFor="let task of doneTasks" 
                 class="kanban-card" 
                 draggable="true"
                 (dragstart)="onDragStart($event, task, 6)">
              <div class="card-content">
                <div class="task-header">
                  <h6 class="task-name" [title]="task.TaskName">{{ truncateTaskName(task.TaskName) }}</h6>
                  <button class="btn-eye" (click)="viewTaskDetails(task); $event.stopPropagation()" title="View Details">
                    <i class="fa fa-eye"></i>
                  </button>
                </div>
                <p class="task-description" *ngIf="task.Description">{{ task.Description }}</p>
                <div class="task-meta">
                  <div class="meta-item" *ngIf="task.CompletedDate">
                    <i class="fa fa-calendar-check-o"></i>
                    <span>{{ formatDate(task.CompletedDate) }}</span>
                  </div>
                  <div class="meta-item" *ngIf="task.AssignedUserName">
                    <i class="fa fa-user"></i>
                    <span>{{ task.AssignedUserName }}</span>
                  </div>
                  <div class="meta-item" *ngIf="task.CategoryName">
                    <i class="fa fa-tag"></i>
                    <span>{{ task.CategoryName }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="doneTasks.length === 0" class="empty-state">
              No done tasks
            </div>
          </div>
        </div>

        <!-- NA Column -->
        <div class="kanban-column" (dragover)="onDragOver($event)" (drop)="onDrop($event, 5)">
          <div class="kanban-header" [style.background-color]="getStatusColor(5)">
            <h5 class="kanban-title">
              <i class="fa fa-minus-circle"></i> NA
              <span class="badge badge-light">{{ getTaskCount(5) }}</span>
            </h5>
          </div>
          <div class="kanban-body">
            <div *ngFor="let task of naTasks" 
                 class="kanban-card" 
                 draggable="true"
                 (dragstart)="onDragStart($event, task, 5)">
              <div class="card-content">
                <div class="task-header">
                  <h6 class="task-name" [title]="task.TaskName">{{ truncateTaskName(task.TaskName) }}</h6>
                  <button class="btn-eye" (click)="viewTaskDetails(task); $event.stopPropagation()" title="View Details">
                    <i class="fa fa-eye"></i>
                  </button>
                </div>
                <p class="task-description" *ngIf="task.Description">{{ task.Description }}</p>
                <div class="task-meta">
                  <div class="meta-item" *ngIf="task.AssignedUserName">
                    <i class="fa fa-user"></i>
                    <span>{{ task.AssignedUserName }}</span>
                  </div>
                  <div class="meta-item" *ngIf="task.CategoryName">
                    <i class="fa fa-tag"></i>
                    <span>{{ task.CategoryName }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="naTasks.length === 0" class="empty-state">
              No N/A tasks
            </div>
          </div>
        </div>

        <!-- Cancelled Column -->
        <div class="kanban-column" (dragover)="onDragOver($event)" (drop)="onDrop($event, 7)">
          <div class="kanban-header" [style.background-color]="getStatusColor(7)">
            <h5 class="kanban-title">
              <i class="fa fa-ban"></i> Cancelled
              <span class="badge badge-light">{{ getTaskCount(7) }}</span>
            </h5>
          </div>
          <div class="kanban-body">
            <div *ngFor="let task of cancelledTasks" 
                 class="kanban-card" 
                 draggable="true"
                 (dragstart)="onDragStart($event, task, 7)">
              <div class="card-content">
                <div class="task-header">
                  <h6 class="task-name" [title]="task.TaskName">{{ truncateTaskName(task.TaskName) }}</h6>
                  <button class="btn-eye" (click)="viewTaskDetails(task); $event.stopPropagation()" title="View Details">
                    <i class="fa fa-eye"></i>
                  </button>
                </div>
                <p class="task-description" *ngIf="task.Description">{{ task.Description }}</p>
                <div class="task-meta">
                  <div class="meta-item" *ngIf="task.AssignedUserName">
                    <i class="fa fa-user"></i>
                    <span>{{ task.AssignedUserName }}</span>
                  </div>
                  <div class="meta-item" *ngIf="task.CategoryName">
                    <i class="fa fa-tag"></i>
                    <span>{{ task.CategoryName }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="cancelledTasks.length === 0" class="empty-state">
              No cancelled tasks
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>

<!-- Task Details Modal -->
<div class="modal fade" id="taskDetailsModal" tabindex="-1" role="dialog" aria-labelledby="taskDetailsModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content" *ngIf="selectedTaskForView">
      <div class="modal-header">
        <h5 class="modal-title" id="taskDetailsModalLabel">
          <i class="fa fa-eye"></i> Task Details - {{ selectedTaskForView.TaskName }}
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeTaskDetailsModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="task-details-container">
          <!-- Task Information Section -->
          <div class="detail-section">
            <h6 class="section-title"><i class="fa fa-info-circle"></i> Task Information</h6>
            <div class="row">
              <div class="col-md-6">
                <div class="detail-item">
                  <label>Task Name:</label>
                  <p>{{ selectedTaskForView.TaskName || 'N/A' }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="detail-item">
                  <label>Task Status:</label>
                  <p><span class="badge" [style.background-color]="getStatusColor(selectedTaskForView.TaskStatus)">
                    {{ getStatusName(selectedTaskForView.TaskStatus) }}
                  </span></p>
                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-md-12">
                <div class="detail-item">
                  <label>Description:</label>
                  <p class="description-text">{{ selectedTaskForView.Description || 'No description available' }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Dates Section -->
          <div class="detail-section">
            <h6 class="section-title"><i class="fa fa-calendar"></i> Dates</h6>
            <div class="row">
              <div class="col-md-4">
                <div class="detail-item">
                  <label>Due Date:</label>
                  <p>{{ formatDate(selectedTaskForView.DueDate) }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="detail-item">
                  <label>Completed Date:</label>
                  <p>{{ formatDate(selectedTaskForView.CompletedDate) }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="detail-item">
                  <label>Created Date:</label>
                  <p>{{ formatDate(selectedTaskForView.CreatedDate) }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Assignment Section -->
          <div class="detail-section">
            <h6 class="section-title"><i class="fa fa-users"></i> Assignment Details</h6>
            <div class="row">
              <div class="col-md-6">
                <div class="detail-item">
                  <label>Assigned To:</label>
                  <p>{{ selectedTaskForView.AssignedUserName || 'Not assigned' }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="detail-item">
                  <label>Owner:</label>
                  <p>{{ selectedTaskForView.Owner || 'N/A' }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Category & Process Section -->
          <div class="detail-section">
            <h6 class="section-title"><i class="fa fa-folder"></i> Classification</h6>
            <div class="row">
              <div class="col-md-6">
                <div class="detail-item">
                  <label>Category:</label>
                  <p>{{ selectedTaskForView.CategoryName || 'N/A' }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="detail-item">
                  <label>Process:</label>
                  <p>{{ selectedTaskForView.ProcessName || 'N/A' }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Additional Information Section -->
          <div class="detail-section" *ngIf="selectedTaskForView.Remarks || selectedTaskForView.EmailContents">
            <h6 class="section-title"><i class="fa fa-comment"></i> Additional Information</h6>
            <div class="row">
              <div class="col-md-12" *ngIf="selectedTaskForView.Remarks">
                <div class="detail-item">
                  <label>Remarks:</label>
                  <p class="description-text">{{ selectedTaskForView.Remarks }}</p>
                </div>
              </div>
              <div class="col-md-12" *ngIf="selectedTaskForView.EmailContents">
                <div class="detail-item">
                  <label>Email Contents:</label>
                  <p class="description-text">{{ selectedTaskForView.EmailContents }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Trigger Information Section -->
          <div class="detail-section" *ngIf="selectedTaskForView.TriggerType || selectedTaskForView.TriggerID">
            <h6 class="section-title"><i class="fa fa-bolt"></i> Trigger Information</h6>
            <div class="row">
              <div class="col-md-6" *ngIf="selectedTaskForView.TriggerType">
                <div class="detail-item">
                  <label>Trigger Type:</label>
                  <p>{{ selectedTaskForView.TriggerType || 'N/A' }}</p>
                </div>
              </div>
              <div class="col-md-6" *ngIf="selectedTaskForView.TriggerID">
                <div class="detail-item">
                  <label>Trigger Name:</label>
                  <p>{{ selectedTaskForView.TriggerID?.Name || 'N/A' }}</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeTaskDetailsModal()">
          <i class="fa fa-times"></i> Close
        </button>
      </div>
    </div>
  </div>
</div>

